import {
  QualityControlFlag,
  QualityControlOutput,
  getQualityControlFlags,
  getQualityControlReviewKey,
  resolveQualityControlFlag,
} from '@aloft/toolkit-shared';

import { useCallback } from 'react';

const isSameFlag = (left: QualityControlFlag, right: QualityControlFlag): boolean =>
  left.category === right.category &&
  left.section === right.section &&
  left.description === right.description;

export const useResolveQualityControlFlag = (
  qualityControl: QualityControlOutput,
  updateQualityControl: (body: QualityControlOutput) => Promise<QualityControlOutput>,
) => {
  const resolveFlag = useCallback(
    async (flag: QualityControlFlag) => {
      const reviewKey = getQualityControlReviewKey(qualityControl, flag);
      if (!reviewKey) return;

      const isStillPending = getQualityControlFlags(qualityControl).some(
        (candidate) => candidate.status === 'pending' && isSameFlag(candidate, flag),
      );
      if (!isStillPending) return;

      const updatedQualityControl = resolveQualityControlFlag(qualityControl, reviewKey, flag);
      await updateQualityControl(updatedQualityControl);
    },
    [qualityControl, updateQualityControl],
  );

  return { resolveFlag };
};
